import { __awaiter, __extends, __generator } from "tslib";
import classNames from 'classnames';
import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { debounce } from '../../utils';
import { classes } from './ProgressBar.st.css';
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            range: 0,
            isSeeking: false,
        };
        _this.change = debounce(function (value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.context.seekTo(value)];
                    case 1:
                        _a.sent();
                        this.setState({
                            isSeeking: false,
                        });
                        if (!this.props.context.isPlayingInterrupted) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.context.play()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 200);
        _this.handleChange = function (event) {
            var value = Number(event.target.value);
            _this.props.context.setFormattedTime(value);
            if (_this.props.context.isSeeking) {
                return;
            }
            var nextRange = value / _this.props.context.duration;
            if (_this.props.context.isPlaying) {
                _this.props.context.pause(true);
            }
            _this.setState({
                range: nextRange,
                isSeeking: true,
            });
            _this.change(+value);
        };
        return _this;
    }
    ProgressBar.getDerivedStateFromProps = function (props, state) {
        if (!state.isSeeking) {
            var nextRange = props.context.currentTime / props.context.duration;
            return {
                range: nextRange || 0,
            };
        }
        return null;
    };
    ProgressBar.prototype.render = function () {
        var _a, _b;
        var _c = this.props.context, buffered = _c.buffered, isLoading = _c.isLoading, handleKeyDown = _c.handleKeyDown, isLiveStream = _c.isLiveStream;
        var range = this.state.range;
        var rangeStyle = { '--value': 100 * range + "%" };
        var ariaNow = Math.round(range * 100);
        var duration = this.props.context.duration;
        var now = range * duration;
        if (!isFinite(duration) || isNaN(duration)) {
            duration = 1.0;
            now = 1.0;
        }
        return (React.createElement("div", { className: classNames(classes.container, this.props.className, (_a = {},
                _a[classes.loading] = isLoading,
                _a)), "data-hook": this.props.dataHook, role: "progressbar" },
            React.createElement("progress", { className: classNames(classes.progress, this.props.classNameProgressBar), max: 100, value: 100 * buffered }),
            React.createElement("input", { type: "range", className: classNames(classes.range, (_b = {}, _b[classes.disabled] = this.props.disabled, _b), this.props.classNameRangeBar), min: "0", max: duration, value: now, step: "0.01", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": ariaNow, "aria-valuetext": ariaNow + "%", style: rangeStyle, onChange: this.handleChange, onKeyDown: handleKeyDown, disabled: isLiveStream || this.props.disabled })));
    };
    ProgressBar.displayName = 'ProgressBar';
    ProgressBar.defaultProps = {
        className: '',
        classNameProgressBar: '',
        classNameRangeBar: '',
        dataHook: '',
        disabled: false,
    };
    return ProgressBar;
}(React.Component));
export default withPlaybackContext(ProgressBar);
//# sourceMappingURL=ProgressBar.js.map